import { BrowserPlayer } from './BrowserPlayer';
/**
 * MediaType.WEB player for the web port. Same broadcast protocol as
 * BrowserPlayer, but websites aren't downloadable media: skip the
 * isDownloaded gate and hand the renderer web_url for its iframe.
 * Vs ElectronWebPlayer: sites sending X-Frame-Options/frame-ancestors
 * won't render, and there is no offline fallback or consent dismissal.
 */
export class WebIframePlayer extends BrowserPlayer {
    preload(item) {
        if (this.preloaded && this.preloaded.item.id === item.id) {
            return;
        }
        const webUrl = item.playable.web_url;
        if (!webUrl) {
            this.logger.warning('[WebIframePlayer] WEB playable has no web_url. Ignoring.', {
                itemId: item.id,
                playableId: item.playable.id,
                __broadcast: this.broadcast,
            });
            return;
        }
        this.logger.debug('[WebIframePlayer] Preloading: ' + item.id, {
            when: new Date().toISOString(),
            name: item.playable.name,
            playableId: item.playable.id,
            url: webUrl,
            __broadcast: this.broadcast,
        });
        const odd = this.currentlyPlaying ? !this.currentlyPlaying.odd : true;
        this.broadcast.broadcast('player:preload', item, odd, webUrl);
        this.preloaded = { odd, item };
    }
}
//# sourceMappingURL=WebIframePlayer.js.map